import React from "react";

// AppLoader rendered as null / minimal clean view to remove all splash screens & loaders
export default function AppLoader() {
  return null;
}
